import { PaymentMethod, SubscriptionServiceType } from './subscription.enums';

export class AccountTypeOverview {
    id: number;
    name: string;
    price: number;
    formattedPrice: string;
    features: string;
    pricingInfo: string;
    description: string;
    hidden: boolean;
    durationDays: number;
    serviceType: SubscriptionServiceType;
}

export class CreateSubscriptionDto {
    accountTypeId: number;
    paymentMethod: PaymentMethod;
    customerId: number;
    additionalInformation?: string;
}

export class CardSubscriptionDto extends CreateSubscriptionDto {
    stripeToken: string;
    automaticRenewal: boolean;
    is3DSecure: boolean;
    clientSecret: string;
}

export class CreateStripePaymentIntentDto {
    selectedAccount: string;
    automaticRenewal: boolean;
    customerId: number;
    email: string;
    subscriptionType?: SubscriptionServiceType;
}

export class GetSubscriptionInfoDto {
    id: number;
    accountTypeId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/subscriptions/subscription.models.ts